import api from './api';

export type HiggsfieldVideoStatus = 'pending' | 'processing' | 'completed' | 'failed';

export interface HiggsfieldVideo {
  id: number;
  higgsfield_id: string | null;
  campaign_id: number | null;
  prompt: string;
  style: string | null;
  aspect_ratio: string;
  duration: number | null;
  status: HiggsfieldVideoStatus;
  video_url: string | null;
  thumbnail_url: string | null;
  error_message: string | null;
  created_at: string;
  created_by: string | null;
}

export interface GenerateVideoPayload {
  prompt: string;
  style?: string;
  aspect_ratio?: '16:9' | '9:16' | '1:1' | '4:5';
  duration?: number;
  campaign_id?: number;
}

class MarketingHiggsfieldService {
  async listVideos(params?: {
    status?: HiggsfieldVideoStatus;
    page?: number;
    limit?: number;
  }): Promise<{ data: HiggsfieldVideo[]; total: number; page: number; limit: number }> {
    const query = new URLSearchParams();
    if (params?.status) query.set('status', params.status);
    if (params?.page) query.set('page', String(params.page));
    if (params?.limit) query.set('limit', String(params.limit));
    const res = await api.get(`/admin/marketing/higgsfield/videos?${query.toString()}`);
    return res.data;
  }

  async generateVideo(payload: GenerateVideoPayload): Promise<HiggsfieldVideo> {
    const res = await api.post('/admin/marketing/higgsfield/generate', payload);
    return res.data.data;
  }

  async refreshVideoStatus(id: number): Promise<HiggsfieldVideo> {
    const res = await api.get(`/admin/marketing/higgsfield/videos/${id}/status`);
    return res.data.data;
  }

  async deleteVideo(id: number): Promise<void> {
    await api.delete(`/admin/marketing/higgsfield/videos/${id}`);
  }
}

export default new MarketingHiggsfieldService();
